import { Route } from '@lumapps/router';
import { URL_PREFIX, AppId } from '@lumapps/router/constants';

export const webviewContentByIdPath = `/${URL_PREFIX}/webview/content/id/:id`;

export const webviewContentViewRoute: Route = {
    path: webviewContentByIdPath,
    appId: AppId.webview,
};

export const getWebviewContentViewRoute = (id: string, instanceSlug?: string): Route => ({
    ...webviewContentViewRoute,
    params: { id },
    instanceSlug,
});
